import { useDepartamentStore } from "../../store";
import { useFormik } from "formik";
import * as Yup from "yup";
import { validateYupStringWithSpecialCharacters } from "helpers/functionsHelpers";
import { useTranslation } from "react-i18next";
import { RequestDepartament } from "interfaces";
import { CreateDepartament, UpdateDepartament } from "services";
import { NotificationType, showNotifications } from "helpers/toas_notification";
import { useDepartamentList } from "../useDepartamentList";

export const useModalDepartament = () => {
  const {
    isEdit,
    isOpenModal,
    departament,
    setDepartament,
    clearAll,
    setIsOpenModal,
  } = useDepartamentStore();
  const { refetchDepartament } = useDepartamentList();
  const { t } = useTranslation();

  const initialValues: RequestDepartament = {
    description: departament?.description || "",
  };

  const validationSchema = Yup.object({
    description: validateYupStringWithSpecialCharacters(t, false),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      try {
        if (departament?.id && isEdit) {
          await updateDepartament(departament.id, values);
        } else {
          await createDepartament(values);
        }
      } catch (error) {
        throw error;
      } finally {
        formik.resetForm();
        setSubmitting(false);
      }
    },
  });

  const createDepartament = async (values: RequestDepartament) => {
    try {
      const response = await CreateDepartament(values);

      if (response.code === "200") {
        setIsOpenModal(false);
        refetchDepartament();
        showNotifications(
          NotificationType.SUCCESS,
          t("notificationsMessages.successAdd")
        );
        clearAll();
      } else {
        clearAll();
        showNotifications(
          NotificationType.ERROR,
          t("notificationsMessages.error") + response.message
        );
      }
    } catch (error) {
      throw error;
    }
  };

  const updateDepartament = async (id: number, values: RequestDepartament) => {
    try {
      const response = await UpdateDepartament(id, values);

      if (response.code === "200") {
        setIsOpenModal(false);
        refetchDepartament();
        showNotifications(
          NotificationType.SUCCESS,
          t("notificationsMessages.success")
        );
        clearAll();
      } else {
        clearAll();
        showNotifications(
          NotificationType.ERROR,
          t("notificationsMessages.error") + response.message
        );
      }
    } catch (error) {
      throw error;
    }
  };

  return {
    isEdit,
    isOpenModal,
    setDepartament,
    formik,
    clearAll,
    setIsOpenModal,
    t,
  };
};
